const PAD = 4
const FOCUS_MS = 3000
let current

export function ensureStyle(doc = document) {
  if (doc.getElementById('zeus-ui-style')) return
  const style = doc.createElement('style')
  style.id = 'zeus-ui-style'
  style.textContent = `
.zeus-ui-highlight { position: fixed; z-index: 1899; pointer-events: none; border: 2px solid #2f6bff; border-radius: 8px; box-shadow: 0 0 0 4px #2f6bff26; animation: zeus-ui-pulse 1.2s ease-out 2; }
.zeus-ui-highlight[data-mode="pick"] { border-style: dashed; box-shadow: none; animation: none; }
.zeus-ui-tip { position: fixed; z-index: 1899; max-width: 280px; padding: 6px 10px; border-radius: 8px; background: #1f2a44; color: #fff; font-size: 12px; line-height: 18px; pointer-events: none; }
@keyframes zeus-ui-pulse { from { box-shadow: 0 0 0 0 #2f6bff55; } to { box-shadow: 0 0 0 10px #2f6bff00; } }
.zeus-ui-picking, .zeus-ui-picking * { cursor: crosshair !important; }
@media (prefers-reduced-motion: reduce) { .zeus-ui-highlight { animation: none; } }`
  doc.head.append(style)
}

/** 当前高亮的模式（hover | focus | pick），没有高亮时为 undefined。 */
export function currentHighlightMode() {
  return current?.mode
}

export function clearHighlight() {
  current?.dispose()
  current = undefined
}

/** 同一时间只有一个高亮。mode: hover（描边）| focus（滚动+气泡，3 秒）| pick（拾取虚线框）。 */
export function highlight({ el, frameEl }, { mode = 'hover', label = '' } = {}) {
  clearHighlight()
  ensureStyle()
  if (mode === 'focus') el.scrollIntoView?.({ block: 'center', inline: 'nearest', behavior: 'smooth' })
  const box = document.createElement('div')
  box.className = 'zeus-ui-highlight'
  box.dataset.mode = mode
  box.setAttribute('aria-hidden', 'true')
  const tip = mode === 'focus' && label ? document.createElement('div') : null
  if (tip) { tip.className = 'zeus-ui-tip'; tip.setAttribute('role', 'status'); tip.textContent = label }
  const place = () => {
    const r = el.getBoundingClientRect()
    const o = frameEl ? frameEl.getBoundingClientRect() : { left: 0, top: 0 }
    Object.assign(box.style, { left: `${r.left + o.left - PAD}px`, top: `${r.top + o.top - PAD}px`, width: `${r.width + PAD * 2}px`, height: `${r.height + PAD * 2}px` })
    if (tip) Object.assign(tip.style, { left: `${r.left + o.left}px`, top: `${r.bottom + o.top + 8}px` })
  }
  place()
  document.body.append(box)
  if (tip) document.body.append(tip)
  const onDown = event => { if (!event.target?.closest?.('#zeus-assistant-panel')) clearHighlight() }
  window.addEventListener('scroll', place, true)
  window.addEventListener('resize', place)
  if (mode !== 'pick') document.addEventListener('pointerdown', onDown, true)
  const timer = mode === 'focus' ? setTimeout(clearHighlight, FOCUS_MS) : undefined
  current = {
    mode,
    dispose() {
      clearTimeout(timer)
      window.removeEventListener('scroll', place, true)
      window.removeEventListener('resize', place)
      document.removeEventListener('pointerdown', onDown, true)
      box.remove(); tip?.remove()
    },
  }
}
